import * as React from 'react';
const SvgArrowThick = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 10, height: 16, fill: "none" }, props),
    React.createElement("path", { fill: "#483B43", d: "M10 2.221 7.809 0 0 7.917l7.809 7.916L10 13.613 4.382 7.916 10 2.22Z" })));
export default SvgArrowThick;
